import { Add, Close } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { consultantAcceptFacilityInvite } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function AcceptToJoinFacility({ open, onClose, facility }) {
  console.log(facility);
  const [saving, setSaving] = useState(false);

  const handleReject = async () => {
    setSaving(true);
    try {
      const payload = {
        approve: false,
        facilityId: facility?.facilityId,
      };
      const res = await consultantAcceptFacilityInvite(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      console.log(error);
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  const handleAccept = async () => {
    setSaving(true);
    try {
      const payload = {
        approve: true,
        facilityId: facility?.facilityId,
      };
      const res = await consultantAcceptFacilityInvite(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      console.log(error);
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Accept to Join
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{}}>
        <Typography>
          You are about to accept the invite from <strong>{facility?.facilityName}</strong> to be
          their consultant.
        </Typography>
        <br />
        <Typography color="error">Are you sure you want to do this?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="error"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          onClick={handleReject}
          sx={{ textTransform: 'none', borderRadius: 20 }}
        >
          Decline
        </Button>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          onClick={handleAccept}
          sx={{ textTransform: 'none', borderRadius: 20 }}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
